export var ItemClass;
(function (ItemClass) {
    ItemClass["Canvas"] = "Canvas";
    ItemClass["Group"] = "Group";
    ItemClass["Mask"] = "Mask";
    ItemClass["Raster"] = "Raster";
    ItemClass["Shape"] = "Shape";
    ItemClass["Path"] = "Path";
    ItemClass["CompoundPath"] = "CompoundPath";
    ItemClass["Slice"] = "Slice";
    ItemClass["Text"] = "Text";
})(ItemClass || (ItemClass = {}));
